import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardEmbed } from '../../components/DashboardEmbed';
import { getDashboardUrlByRole, getDashboardTitle, getDashboardDescription } from '../../config/dashboards';

export const FormationDashboard = ({ user }: { user: any }) => {
  const { t } = useTranslation();
  const role = user?.role;
  return (
    <div className="p-4 md:p-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white mb-1">{t('dashboard.training')}</h1>
        <p className="text-gray-400 text-sm">Évaluation des programmes de formation</p>
      </div>
      <DashboardEmbed title={getDashboardTitle('training')} embedUrl={getDashboardUrlByRole(role,'training')} description={getDashboardDescription('training')} userRole={role}/>
    </div>
  );
};
